import React from 'react';
import HeroBanner from '../components/HeroBanner';
import { clientPartnersContent } from '../mock';

const ClientPartners = () => {
  return (
    <>
      <HeroBanner
        image={clientPartnersContent.heroImage}
        quote={clientPartnersContent.heroQuote}
        tall={false}
      />

      <section className="bg-[#e5dfe9] py-24 md:py-32">
        <div className="max-w-4xl mx-auto px-6">
          <h2
            className="font-serif italic text-center text-neutral-800 mb-12"
            style={{ fontSize: 'clamp(1.8rem, 3.4vw, 2.5rem)' }}
          >
            {clientPartnersContent.heading}
          </h2>

          <p
            className="text-neutral-700 font-sans max-w-3xl mx-auto text-center"
            style={{ fontSize: '17px', lineHeight: '1.75' }}
          >
            {clientPartnersContent.intro}
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mt-16 max-w-3xl mx-auto">
            {clientPartnersContent.industries.map((label, i) => (
              <div
                key={i}
                className="border border-neutral-500/30 bg-white/40 backdrop-blur-sm rounded-sm py-6 px-4 text-center hover:bg-white/70 transition-colors"
              >
                <span className="font-sans text-[13px] tracking-[0.18em] text-neutral-700 uppercase">
                  {label}
                </span>
              </div>
            ))}
          </div>

          <p
            className="text-neutral-700 font-sans max-w-3xl mx-auto text-center mt-16"
            style={{ fontSize: '17px', lineHeight: '1.75' }}
          >
            {clientPartnersContent.closing}
          </p>
        </div>
      </section>
    </>
  );
};

export default ClientPartners;
